import React from "react";

function DidntFindWhatYouWereLookingFor() {
    return (
        <>
            <section
                className="section section-lg pt-0 bg-dark text-light line-bottom-light"
                id="didntfindwhatyouwerelookingfor"
            >
                <div className="container">
                    <div className="row">
                        <div className="col-12 col-lg-7 col-md-6 mt-lg-7 mt-5">
                            <div className="font-size-34 d-none d-md-block">
                                Didn’t find what you were looking for?
                            </div>
                            <div className="font-size-26 d-block d-md-none">
                                Didn’t find what you were looking for?
                            </div>
                            <p className="mt-1 mb-3 text-white-50 font-medium">
                                Talk to us on WhatsApp and we'll see how we can
                                help
                            </p>
                            <div className="btn-cont col-4 col-lg-3 px-0 mt-5">
                                <a
                                    className="btn btn-success btn-block"
                                    href="https://api.whatsapp.com/send?phone=+254769411616"
                                    itemProp="telephone"
                                >
                                    <i className="fab fa-whatsapp fa-3x"></i>
                                    WhatsApp Us
                                </a>
                            </div>
                            <div className="pt-3">
                                <p className="my-2 text-white-50 font-medium">
                                    Our WhatsApp number is{" "}
                                    <b>+254 701 220 004</b>
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </>
    );
}

export default DidntFindWhatYouWereLookingFor;
